module.exports = __webpack_public_path__ + "img/pecheur.934ad980.png";